import React from 'react';
import Axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AutoSuggestPlayer from '../shared/AutoSuggest/AutoSuggestPlayer';
import { HANDICAPTYPE } from "../shared/constants/constants";


const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
};


class ScoresheetAddSubModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPlayerId: null,
      bGenericSubEnabled: false,
      genericSubPlayer: {
        trs: "",
        notes: ""
      },
      trsList: [],
      disableSubmit: false,
    };
  }

  componentDidMount() {
    this.loadParameters();
  }
  
  componentDidUpdate(prevProps) {
    //console.log('SeasonAdminGen: componentDidUpdate: ');
    //if (prevProps.season !== this.props.season) {
    // this.loadParameters(this.props.season)
    //}
  }

  loadParameters() {
    Axios.get('/api/ratingTypes')
      .then(respRatingTypes => {
        const rtt = respRatingTypes.data.find(rrt => rrt.name === "QVNEA - TRS");
        let trsList = rtt ? rtt.values : [];
        trsList = [...trsList, "Inconnu"];
        this.setState({ trsList });
      })
      .catch(err => {
        console.error('Error loading rating types', err);
        this.setState({ trsList: [] });
      });
  }

  handleSelect = (playerId) => {
  	// console.log("handleSelect playerId", playerId)
    // Callback de AutoSuggestPlayer
	  this.setState({ selectedPlayerId: playerId });
  }



  //Corriger cette fonction
  //Gérer les 2 options du bGenericSubEnabled
  //Gérer selectedPlayerId selon l'option


  handleConfirm = (e) => {
    e.preventDefault();
    const { bGenericSubEnabled, genericSubPlayer } = this.state;
    let { selectedPlayerId } = this.state;

  	// console.log("handleConfirm", selectedPlayerId)
    if (!bGenericSubEnabled) {
      if (!selectedPlayerId) {
        alert("Choisir un joueur substitut.");
        return;
      }
    }

    // Prevent "Cote TRS" et aucun TRS sélectionné
    if (bGenericSubEnabled && (this.props.handicapType === HANDICAPTYPE.TRS) && (
       (genericSubPlayer.trs === "") || (genericSubPlayer.trs === "Inconnu")
      )) {

      alert("Déterminer un TRS");
      return;
    }

    // Seek playerId for this Sub
    const seekFirstname = "Substitut";
    const seekLastname = `TRS ${genericSubPlayer.trs || ''}`;
    const seekSpecial = "_";

    const subNotes =
      genericSubPlayer.notes?.trim()
        ? `SUB TRS ${genericSubPlayer.trs} ${genericSubPlayer.notes.trim()}`
        : "";

    Axios.get('/api/players/byName/' + 
      encodeURIComponent(seekFirstname) + '/' +
      encodeURIComponent(seekLastname) + '/' +
      encodeURIComponent(seekSpecial))
    .then(responsePlayer => {
      selectedPlayerId = responsePlayer.data._id;
      console.log("FOUND PLAYER", selectedPlayerId)
      
      this.setState({ disableSubmit: true });

      // Retourne le joueur choisi au parent
      this.props.handleConfirm(selectedPlayerId, genericSubPlayer.notes);
    });

  }

  render() {
    console.log("RENDER - ScoresheetAddSubModal")
    // console.log(this.state);
    // console.log(this.props);

    const { showModal, handleCancel } = this.props;
    const { disableSubmit } = this.state;
    const { bGenericSubEnabled, genericSubPlayer } = this.state;

    return (
      <Modal
        isOpen={showModal}
        size="sm"
        className={this.props.className}
      >
        <form className="form-horizontal" onSubmit={this.handleConfirm}>
          <ModalHeader>
            Ajouter un substitut
          </ModalHeader>

          <ModalBody>
            <div className="row row-margin-bottom-10">
              <div className="col-12">
                <span className="small boldText">Choisir un joueur substitut</span><br/>
                <span className="small">Entrer son nom dans la boîte de recherche</span><br/>

								<AutoSuggestPlayer 
									key={this.state.selectedPlayerId || 'autosugg-sub'}
									id='playerId' theme={autoSuggTheme} 
									playerId={this.state.selectedPlayerId || '0'} 
									dataChange={this.handleSelect} disabled={bGenericSubEnabled} />
              </div>
            </div>

            <div className="row row-margin-bottom-10">
            <div className="col-12">
              <label className="switch switch-3d switch-sm switch-success form-control-label">
              <input type="checkbox" className="switch-input form-check-input" 
                checked={bGenericSubEnabled || false} onChange={this.handleGenericSubEnabledChange}/>               
                <span className="switch-label"></span>
              <span className="switch-handle"></span>
              </label>
              &nbsp;&nbsp;Joueur substitut introuvable
            </div>
            </div>

            {bGenericSubEnabled ? 
            <>
            <hr/>
            <div className="row row-margin-bottom-10">
              <div className="col-12">
                <span className="small boldText">Joueur substitut introuvable ?</span><br/>
                <span className="small">Choisir un substitut générique selon le TRS</span><br/>
              </div>

              <div className="col-6">
                <label htmlFor="trs" className="small labelSmallMarginBottom">TRS</label>
                <select
                  id="trs" className="form-control form-control-sm"
                  value={genericSubPlayer.trs || ''} onChange={this.handleSubdataChange}>
                  
                  <option value="" disabled>-- Sélectionner --</option>
                  {this.state.trsList.map(trs => (
                    <option key={trs} value={trs}>{trs}</option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <label htmlFor="notes" className="small labelSmallMarginBottom">Notes (prénom, nom, autres infos)</label>
                <input className="form-control form-control-sm" type="text" id="notes" 
                  value={genericSubPlayer.notes || ''} onChange={this.handleSubdataChange} />
              </div>

            </div>
            </>
            : null}

          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary btn-sm stdCommandButton2"
              onClick={handleCancel}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-sm stdCommandButton2"
              disabled={disableSubmit}
            >
              Confirmer
            </button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }

  handleSubdataChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      genericSubPlayer: {
        ...prevState.genericSubPlayer,
        [id]: value
      }
    }));
  };

  handleGenericSubEnabledChange = (e) => {
    const { checked } = e.target;
    this.setState({ bGenericSubEnabled: checked });
  };
}

export default ScoresheetAddSubModal;
